import { BaseRouteService } from 'core/services';

class ScheduleRouteService extends BaseRouteService {
    constructor() {
        super('facility-schedule-dates');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,dateFrom,dateTo,dateOfServiceFrom,dateOfServiceTo,facilityId,areaOfCareId,accountRepId,calendarTypeId,payorRepId,intakeRepId,documentRepId,billerRepId,assigneeWithUserId,notAssigneeWithUserId,isNew,isDone,isReminderIntake,isReminderPayor,isReminderDocument,isReminderBiller,isWoundCare,corporateId,parentFacilityScheduleDateId,isMissingReport,isOnHold,facilityOrderId,areaOfCareIdToExclude}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    getUserDaily(options) {
        return super.get(this.base + '/user-daily/{?embed}', null, options);
    }

    getPastOrders(options) {
        return super.get(this.base + '/past-orders/{?embed,sort,facilityId,date,calendarTypeId}', null, options);
    }

    getPreviousTasks(options) {
        return super.get(this.base + '/previous-tasks/{?embed,sort,facilityId,date,calendarTypeId,rpp,fields,numberOfDays}', null, options);
    }

    getFutureTasks(options) {
        return super.get(this.base + '/future-working-date-tasks/{fromDay}{?embed,rpp,sort,shipPoint,calendarTypeId,isOnHold}', null, options);
    }

    getCurrentTasksByRoles(options) {
        return super.get(this.base + '/current-by-roles/{?role,daysAhead,embed,sort,isOnHold}', null, options);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    updateLinkedTask(resource) {
        return super.update(this.base + '/update-linked-task/{id}', resource);
    }   

    updateDates(resource) {
        return super.update(this.base + '/update-dates', resource);
    }   

    updateDate(resource) {
        return super.update(this.base + '/update-date', resource);
    }   

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    regenerate(resource){
        return super.create(this.base + '/regenerate', resource);
    }

    generate(resource){
        return super.create(this.base + '/generate', resource);
    }

    getTypes(){
        return super.get(this.base + '/types');        
    }

    copyNote(resource) {
        return super.update(this.base + '/{id}/copyNote', resource);
    }
    
    sendOrder(resource) {
		return super.update(`${this.base}/send-order/{pickTicketHeaderId}`, resource);	
	}

	batchUpdate(resource) {
		return super.batchUpdate(`${this.base}/batch`, resource);	
	}

    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,sort,dateOfServiceFrom,dateOfServiceTo,corporateId,facilityId,calendarTypeId}', filter);    
    }

    sendOrderNewFlow(resource) {
		return super.update(`${this.base}/send-order-new-flow/{pickTicketHeaderId}`, resource);	
	}

    sendOrderOrderSummaryNewFlow(resource) {
		return super.update(`${this.base}/send-order-order-summary-new-flow/{facilityOrderId}`, resource);	
	}
}

export default ScheduleRouteService;